export enum SiteTypeEnum {
  AppleBusinessChat = 'business-chat',
  Facebook = 'facebook',
  GoogleBusinessMessages = 'gbm',
  GoogleBusinessProfile = 'gmb',
  InMessage = 'webchat',
  Instagram2 = 'instagram2',
  Trustpilot = 'trustpilot',
  Twitter = 'twitter',
  WhatsApp = 'whatsapp',
  Line = 'line',
  Kakaotalk = 'kakaotalk',
  Linkedin = 'linkedin',
  Tiktok = 'tiktok',
}
